import * as React from 'react';
import {getReactButton} from "../../index";

export interface ReactInputData {
    id?: string,
    type?: string,
    onChange?: (rowObj: any, rowIndex: number) => null,
    onKeyDown?: (rowObj: any, key: string, rowIndex: number) => boolean,
    onKeyUp?: (rowObj: any, key: string, value: string, rowIndex: number) => null,
    onFocus?: (rowObj: any, rowIndex: number) => null,
    onBlur?: (rowObj: any, rowIndex: number) => null,
    row: any,
    rowIndex: number,
    style?: {},
    css?: string,
    disabled?: boolean,
    disableID?: string,
    refreshID?: string,
    onRefresh?: () => {},
    dataKey: string,
    tabIndex?: null,
    title?: string,
}

export interface ReactInputState {
    row: any,
    acceptKey: boolean,
    disabled: boolean,
}

export class ReactInput extends React.Component<ReactInputData> {
    constructor(props: ReactInputData) {
        super(props);

        this.state = {
            row: props.row,
            acceptKey: true,
            disabled: props.disabled,
        };

        // Binding is necessary to allow these functions access to the State data
        this.handleChange = this.handleChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onDisableClick = this.onDisableClick.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
    }

    // Update the state externally
    componentWillReceiveProps(props: ReactInputData) {
        this.setState({
            row: props.row,
            disabled: props.disabled,
        });
    }

    onRefresh() {
        if(null != this.props.onRefresh) {
            this.props.onRefresh();
        }

        this.setState(() => ({
            row: (this.state as ReactInputState).row,
        }));
    }

    handleChange(event: React.FormEvent<HTMLInputElement>) {
        if((this.state as ReactInputState).acceptKey) {
            const newVal = event.currentTarget.value;
            this.setState(() => {
                (this.state as ReactInputState).row[this.props.dataKey] = newVal;

                return {
                    row: (this.state as ReactInputState).row
                }
            }, () => {
                if (null != this.props.onChange) {
                    this.props.onChange((this.state as ReactInputState).row, this.props.rowIndex);
                }
            });
        }
    }

    onFocus(event: any) {
        if (null != this.props.onFocus) {
            this.props.onFocus((this.state as ReactInputState).row, this.props.rowIndex);
        }
    }

    onBlur(event: any) {
        if (null != this.props.onBlur) {
            this.props.onBlur((this.state as ReactInputState).row, this.props.rowIndex);
        }
    }

    onKeyUp(event: React.KeyboardEvent<HTMLInputElement>) {
        if (null != this.props.onKeyUp) {
            this.props.onKeyUp((this.state as ReactInputState).row, event.key, event.currentTarget.value, this.props.rowIndex);
        }
    }

    onKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
        let acceptKeyDown = true;
        if (null != this.props.onKeyDown) {
            acceptKeyDown = this.props.onKeyDown((this.state as ReactInputState).row, event.key, this.props.rowIndex);
        }
        this.setState({
            acceptKey: acceptKeyDown
        });
    }

    onDisableClick(event: any) {
        const isChecked = $(event.currentTarget).is(":checked");
        this.setState({
            disabled: isChecked
        });
    }

    getInput() {
        if(this.props.title) {
            return <input
                id={this.props.id}
                type={this.props.type}
                className={this.props.css}
                tabIndex={this.props.tabIndex}
                style={this.props.style}
                onChange={this.handleChange}
                onKeyDown={this.onKeyDown}
                onKeyUp={this.onKeyUp}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                value={(null != (this.state as ReactInputState).row[this.props.dataKey] && 'undefined' != (this.state as ReactInputState).row[this.props.dataKey]) ? (this.state as ReactInputState).row[this.props.dataKey] : ''}
                disabled={(this.state as ReactInputState).disabled}
                title={this.props.title}
            />;
        } else {
            return <input
                id={this.props.id}
                type={this.props.type}
                className={this.props.css}
                tabIndex={this.props.tabIndex}
                style={this.props.style}
                onChange={this.handleChange}
                onKeyDown={this.onKeyDown}
                onKeyUp={this.onKeyUp}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                value={(null != (this.state as ReactInputState).row[this.props.dataKey] && 'undefined' != (this.state as ReactInputState).row[this.props.dataKey]) ? (this.state as ReactInputState).row[this.props.dataKey] : ''}
                disabled={(this.state as ReactInputState).disabled}
            />;
        }
    }

    render() {
        return <React.Fragment>
            {<table className="categoryAllHide"><tr>
                <td><input
                    id={this.props.disableID}
                    type="checkbox"
                    onChange={this.onDisableClick}
                    checked={(this.state as ReactInputState).disabled}
                /></td>
                <td>
                    HIDDEN DISABLE BUTTON
                </td>
            </tr></table>
            }
            {getReactButton({id: this.props.refreshID, css: "categoryAllHide", onClick: this.onRefresh, text: "HIDDEN REFRESH BUTTON"})}
            {this.getInput()}
        </React.Fragment>;
    }
}
